import { Module } from 'vuex';

export interface NavigationState {
  isRouteLoading: boolean;
}

const navigationModule: Module<NavigationState, Record<string, unknown>> = {
  namespaced: true,

  state: (): NavigationState => ({
    isRouteLoading: false,
  }),

  getters: {
    isRouteLoading(state): boolean {
      return state.isRouteLoading;
    },
  },

  mutations: {
    START_ROUTE_LOADING(state): void {
      state.isRouteLoading = true;
    },

    STOP_ROUTE_LOADING(state): void {
      state.isRouteLoading = false;
    },
  },
};

export default navigationModule;
